/**
 * The Ledger Spinner: a ring in currentColor at 14 (`xs`), 16 (`sm`) or 20
 * (`md`) px. Only inside a button or beside a save status; a page never shows
 * a spinner of its own (it shows a skeleton). Announces "Loading" unless a
 * label is given.
 *
 * Spec: specs/design-system/ledger-primitives.feature
 */
import {
  Spinner as ChakraSpinner,
  type SpinnerProps as ChakraSpinnerProps,
} from "@chakra-ui/react";
import * as React from "react";

export interface SpinnerProps extends ChakraSpinnerProps {
  /** What is in progress, for screen readers. */
  label?: string;
}

export const Spinner = React.forwardRef<HTMLSpanElement, SpinnerProps>(
  function Spinner({ label = "Loading", size = "sm", ...rest }, ref) {
    return (
      <ChakraSpinner
        ref={ref}
        size={size}
        role="status"
        aria-label={label}
        {...rest}
      />
    );
  },
);
